import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaInstagram, FaTwitter, FaLinkedin, FaEnvelope, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-light mt-5 pt-4 pb-3 shadow-sm">
      <div className="container">
        <div className="row g-4">
          {/* About section */}
          <div className="col-lg-3 col-md-6 col-sm-12">
            <h5 className="mb-3">About StoreToYou</h5>
            <p className="text-muted small">
              StoreToYou helps you discover unique local businesses in your area. 
              Shop local, support your community, and find products you'll love.
            </p>
          </div>

          {/* Quick Links */}
          <div className="col-lg-3 col-md-6 col-sm-12">
            <h5 className="mb-3">Quick Links</h5>
            <ul className="list-unstyled">
              <li className="mb-2">
                <Link to="/" className="text-decoration-none text-muted small">Home</Link>
              </li>
              <li className="mb-2">
                <Link to="/city/kelowna" className="text-decoration-none text-muted small">Kelowna Stores</Link>
              </li>
              <li className="mb-2">
                <Link to="/city/vancouver" className="text-decoration-none text-muted small">Vancouver Stores</Link>
              </li>
              <li className="mb-2">
                <Link to="/categories" className="text-decoration-none text-muted small">Browse Categories</Link>
              </li>
              <li className="mb-2">
                <Link to="/for-business" className="text-decoration-none text-muted small">For Business Owners</Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="col-lg-3 col-md-6 col-sm-12">
            <h5 className="mb-3">Contact Us</h5>
            <ul className="list-unstyled">
              <li className="mb-2 d-flex align-items-center">
                <FaEnvelope className="me-2 text-muted" />
                <a href="mailto:info@storetoyou.ca" className="text-decoration-none text-muted small">
                  info@storetoyou.ca
                </a>
              </li>
              <li className="mb-2 d-flex align-items-center">
                <FaPhone className="me-2 text-muted" />
                <span className="text-muted small">+1 (123) 456-7890</span>
              </li>
              <li className="mb-2 d-flex align-items-center">
                <FaMapMarkerAlt className="me-2 text-muted" />
                <span className="text-muted small">Kelowna, BC, Canada</span>
              </li>
            </ul>
          </div>

          {/* Newsletter / Follow */}
          <div className="col-lg-3 col-md-6 col-sm-12">
            <h5 className="mb-3">Stay Connected</h5>
            <p className="text-muted small mb-2">
              Follow us on social media for updates, new store listings, and local shopping deals.
            </p>
            <div className="d-flex gap-3 mb-3">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-decoration-none">
                <FaFacebook size={20} className="text-muted" />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-decoration-none">
                <FaInstagram size={20} className="text-muted" />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-decoration-none">
                <FaTwitter size={20} className="text-muted" />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-decoration-none">
                <FaLinkedin size={20} className="text-muted" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom section with copyright and links */}
        <hr className="my-3" />
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
          <div className="text-muted small mb-2 mb-md-0">
            © {currentYear} StoreToYou. All rights reserved.
          </div>
          <div className="d-flex gap-3">
            <Link to="/privacy" className="text-decoration-none text-muted small">Privacy Policy</Link>
            <Link to="/terms" className="text-decoration-none text-muted small">Terms of Service</Link>
            <Link to="/faq" className="text-decoration-none text-muted small">FAQ</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;